module.exports = __webpack_public_path__ + "bcb8934a7fb67ed848765b88cf974425.fbx";